import { render, staticRenderFns } from "./SignalementMailModal.vue?vue&type=template&id=46d899e6"
import script from "./SignalementMailModal.vue?vue&type=script&lang=ts"
export * from "./SignalementMailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports